import React, { useRef } from "react";
import Button from "components/common/Button";
import PopupModal, { PopupModalRef } from "components/common/PopupModal";
import ModalContent from "components/modals/ModalContent";
import BookingService from "services/booking";
import { useNotification } from "hooks/useNotification";
import { get } from "utils/lodash";
import { UserX } from "lucide-react";

interface NotComeBookingProps {
  booking: any;
  onSuccess?: (res?: any) => void;
  onFail?: (error?: any) => void;
  className?: string;
}

export default function NotComeBooking({
  booking,
  onSuccess,
  onFail,
  className,
}: NotComeBookingProps) {
  const modalRef = useRef<PopupModalRef>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const notification = useNotification();
  const bookingId = get(booking, "id", "");

  const customerName = get(booking, "populatedUser[0].name") ||
                      get(booking, "user.name") ||
                      "khách hàng";

  const handleNotCome = async () => {
    try {
      setIsLoading(true);
      const res = await BookingService.notShowBooking({ id: bookingId });
      onSuccess?.(res);
      notification.success("Đã chuyển trạng thái khách không đến");
      modalRef.current?.close();
    } catch (error) {
      notification.error("Đã chuyển trạng thái khách không đến thất bại");
      onFail?.(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        className={className}
        variant="outline"
        size="sm"
        loading={isLoading}
        onClick={() => modalRef.current?.open()}
      >
        <span className="font-semibold">Không đến</span>
      </Button>
      <PopupModal ref={modalRef}>
        <ModalContent
          content={
            <div className="flex flex-col items-center gap-4">
              <UserX className="w-12 h-12 text-orange-500" />
              <label className="text-center">
                Xác nhận khách hàng{" "}
                <span className="font-semibold">{customerName}</span>{" "}
                không đến?
              </label>
            </div>
          }
          closable
          cancelLabel="Hủy"
          acceptLabel="Xác nhận không đến"
          onAccept={handleNotCome}
          onCancel={() => modalRef.current?.close()}
        />
      </PopupModal>
    </>
  );
}